import { render } from "./HomePageSlogan.vue?vue&type=template&id=09c6c3da&scoped=true"
const script = {}

import "./HomePageSlogan.vue?vue&type=style&index=0&id=09c6c3da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c6c3da"]])

export default __exports__